import React, { useState, Suspense, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { setIsModalOpenFAQ, setFaqParentId } from 'actions/Login/login.action';
import { Button, Switch, Checkbox } from 'antd';
import { publish } from 'app/libs/core/PubSub';
import * as way from 'app/libs/core/PubSubWays';
import * as types from 'app/actions/action_types';
import { CloseOutlined, CheckOutlined, DownOutlined } from '@ant-design/icons';
import { isIE, isMobile } from 'react-device-detect';
import { useDispatch } from 'react-redux';
import { useActions } from 'app/components/Utility/hooks/useAction.hooks';
import withTranslations from 'app/components/HOGs/withTranslations';
import { TourCorrectIcon } from '../icons.svg';
import { Type } from '../../../../constants/TourPoints';
import shapingPoint from '../../../../../static/images/icons/shaping_point.png';
import { retry } from '../../../Utility/loadingChunkErrorHandler';
import TTOTitle from '../components/TtoTitle';
import ToolbarLayout from '../components/toolbars';
import { ErrorBoundary } from '../../../Utility/errorBoundary';
import { setShapingPoints } from '../../../../actions/FullTour/full_tour_view.action';
import RideTwister from '../RideTwister/RideTwister';
import ShowPlaces from '../ShowPlaces/ShowPlaces';

const FaqComponent = React.lazy(() => retry(() => import('../../FAQ/faq')));

const OptimizeMenu = (props) => {
  const {
    unpaved,
    ferry,
    highway,
    tr,
    isAutocorrectionEnabled,
    isCorrectViaAvailable,
    isCorrectDragAvailable,
    setAutoCorrectStatus,
    setCorrectViaStatus,
    setCorrectDragStatus,
    goToFAQ,
    isEditMode,
    isMenuHidden,
    isCorrectSwitcherEnabled,
    isShapingVisible,
    isRidePlan,
  } = props;

  const dispatch = useDispatch();

  const switchShapingUpnavedRoutes = () => {
    setTimeout(() => {
      publish(way.SAVE_TB_SWITCH_SHAPING_UNPAVED_ROUTES, {});
    }, 0);
  };

  const switchShapingPoints = (isEnable) => {
    dispatch(setShapingPoints(isEnable));
    switchShapingUpnavedRoutes();
  };

  useEffect(() => {
    if (isEditMode === false && isShapingVisible) {
      switchShapingPoints(isEditMode);
    }
  }, [isEditMode]);

  const handleAutoCorrection = (isEnabled) => {
    setAutoCorrectStatus(isEnabled);
    if (isEnabled) publish(way.MOVE_POINTS_SHORT_WRONG_DIST_TO_ROUTE, {});
  };

  const handleCorrectionVia = (isEnabled) => {
    if (!isEnabled && !isCorrectDragAvailable) {
      setAutoCorrectStatus(false);
    }
    setCorrectViaStatus(isEnabled);
    publish(way.CHANGE_CORRECTION_WRONG_ROUTE_STATUS, {
      isEnabled,
      type: Type.VIA,
    });
  };

  const handleCorrectionDrag = (isEnabled) => {
    if (!isEnabled && !isCorrectViaAvailable) {
      setAutoCorrectStatus(false);
    }
    setCorrectDragStatus(isEnabled);
    publish(way.CHANGE_CORRECTION_WRONG_ROUTE_STATUS, {
      isEnabled,
      type: Type.DRAG,
    });
  };

  const updateMapRoutes = () => {
    setTimeout(() => {
      publish(way.SAVE_TB_UPDATE_ALL_POLYS, {});
    }, 0);
    // stop
  };

  const changeUnpaved = (val) => {
    dispatch({
      type: types.TOUR_FULL_DATA_AVOID_UNPAVED,
      payload: val.target.checked,
    });
    switchShapingUpnavedRoutes();
  };

  const changeHighway = (val) => {
    dispatch({
      type: types.TOUR_FULL_DATA_AVOID_HIGHWAY,
      payload: val.target.checked,
    });
    switchShapingPoints(val.target.checked);
    updateMapRoutes();
  };

  const changeFerry = (val) => {
    dispatch({
      type: types.TOUR_FULL_DATA_AVOID_FERRY,
      payload: val.target.checked,
    });
    switchShapingPoints(val.target.checked);
    updateMapRoutes();
  };

  const isSettngsAvailable = () => isRidePlan || isEditMode;

  const isShapingSwitcherAvailable = () =>
    (isRidePlan && !highway && !ferry) || (isEditMode && !highway && !ferry);

  const getClass = () =>
    !isMenuHidden
      ? 'menu-items-optimize-wrap am-heigh-up-leave am-heigh-up-leave-active'
      : 'menu-items-optimize-wrap am-heigh-up-enter am-heigh-up-enter-active';

  const getActiveClass = () =>
    isCorrectSwitcherEnabled ? '' : 'switcher_not_enabled';

  const getViewClass = () => (isRidePlan || isEditMode ? '' : 'switcher_view');

  const getColor = () => (isSettngsAvailable() ? '#333333' : '#b9b9b8');

  const getShapingColor = () =>
    isShapingSwitcherAvailable() ? '#333333' : '#b9b9b8';

  const getShapingSwitcherStatus = () => {
    let status = isShapingVisible;

    if (!isShapingVisible && (highway || ferry)) {
      status = true;
      // dispatch(setShapingPoints(status));
    }
    return status;
  };

  const getShapingIconStyle = (
    isShapingSwitcherAvailable,
    getShapingSwitcherStatus
  ) => {
    const style = {
      width: 16,
      height: 16,
      margin: '2px 5px',
      opacity:
        !isShapingSwitcherAvailable() || !getShapingSwitcherStatus() ? 0.5 : 1,
    };
    return style;
  };

  return (
    <div className={`${getClass()} ${getActiveClass()} ${getViewClass()}`}>
      <div
        className={!isEditMode || !isCorrectSwitcherEnabled ? 'hidden-div' : ''}
      >
        <div className="optimize-menu-group-lable">
          {tr['Point optimization']}
        </div>
        <div className="optimize-menu-item">
          <div className="disabled-text" id="full-map-overlay-list">
            {tr['Correct via point']}
          </div>
          <Switch
            checkedChildren={<CheckOutlined />}
            unCheckedChildren={<CloseOutlined />}
            checked={isCorrectViaAvailable}
            onClick={handleCorrectionVia}
            size="small"
            className="correct-switchers"
          />
        </div>
        <div className="optimize-menu-item">
          <div className="disabled-text">{tr['Correct drag point']}</div>
          <Switch
            checkedChildren={<CheckOutlined />}
            unCheckedChildren={<CloseOutlined />}
            checked={isCorrectDragAvailable}
            onClick={handleCorrectionDrag}
            size="small"
            className="correct-switchers"
          />
        </div>
        <div className="optimize-menu-item">
          <div className="disabled-text">{tr['Auto drag to route']}</div>
          <Switch
            checkedChildren={<CheckOutlined />}
            unCheckedChildren={<CloseOutlined />}
            checked={isAutocorrectionEnabled}
            onChange={handleAutoCorrection}
            size="small"
            className="correct-switchers"
          />
        </div>
      </div>
      <div className="optimize-menu-group-lable">{tr['Route options']}</div>
      <div className="avoid-list-wrapper">
        <div className="avoid-list-item unpaved-selector-wrapper">
          <Checkbox
            checked={unpaved}
            onChange={changeUnpaved}
            data-attr="unpaved"
          />
          <span style={{ marginLeft: '10px', color: '#333333' }}>
            {tr['Highlight unpaved roads']}
          </span>
          <div className="unpaved-selector" />
        </div>
        <div className="avoid-list-item">
          <Checkbox
            checked={highway}
            onChange={changeHighway}
            disabled={!isSettngsAvailable()}
          />
          <span
            style={{ marginLeft: '10px', color: getColor() }}
            data-attr="highway"
          >
            {tr['Avoid highway']}
          </span>
        </div>
        <div className="avoid-list-item">
          <Checkbox
            checked={ferry}
            onChange={changeFerry}
            disabled={!isSettngsAvailable()}
          />
          <span
            style={{ marginLeft: '10px', color: getColor() }}
            data-attr="ferry"
          >
            {tr['Avoid Ferry']}
          </span>
        </div>
      </div>
      <div className="optimize-menu-group-lable">
        {tr['Route shaping points']}
      </div>
      <div className="optimize-menu-item">
        <div className="disabled-text" style={{ color: getShapingColor() }}>
          {tr['Show shaping points']}
        </div>
        <img
          src={shapingPoint}
          alt="shaping point"
          style={getShapingIconStyle(
            isShapingSwitcherAvailable,
            getShapingSwitcherStatus
          )}
        />
        <Switch
          checkedChildren={<CheckOutlined />}
          unCheckedChildren={<CloseOutlined />}
          checked={getShapingSwitcherStatus()}
          onChange={switchShapingPoints}
          size="small"
          className="correct-switchers"
          disabled={!isShapingSwitcherAvailable()}
        />
      </div>
      <div className="line-top" />
      <div className="optimize-menu-item">
        <div className="disabled-last-text">{tr['See in']}</div>
        <div
          className="disabled-help"
          onClick={(e) => {
            e.preventDefault();
            console.log(281);
            goToFAQ(true);
          }}
          aria-hidden
        >
          {tr.Help}
        </div>
        <div className="disabled-last-text">{tr['more details']}</div>
      </div>
    </div>
  );
};

let hiddenMenuDelay = null;

const GetSwitcher = (props) => {
  const {
    isFullScreenModeEnabled,
    isAutocorrectionEnabled,
    isCorrectViaAvailable,
    isCorrectDragAvailable,
    isCorrectSwitcherAvailb,
    isModalOpenFAQ,
    tr,
    isWrongRoutesExists,
    unpaved,
    ferry,
    highway,
    isEditMode,
    style = {},
    isShapingVisible,
    isTtoVisible,
    isRidePlan,
    hasUserPermition,
    currentTourId,
    closePreview,
    fullScreenMode,
  } = props;
  const [isOpenFaq, setOpenFaq] = useState(false);
  const [isCorrectSwitcherEnabled, setSwitcherVal] = useState(
    isCorrectSwitcherAvailb
  );
  const [isMenuHidden, setMenuHidden] = useState(isTtoVisible);
  const dispatch = useDispatch();

  const {
    setAutoCorrectStatus,
    setCorrectDragStatus,
    setCorrectViaStatus,
    setCorrectionStatus,
  } = useActions();

  useEffect(() => {
    setMenuHidden(isTtoVisible);
  }, [isTtoVisible]);

  const goToFAQ = (open = false) => {
    setOpenFaq(open);
    dispatch(setIsModalOpenFAQ(open));
    dispatch(setFaqParentId(open ? +process.env.OPTIMAZE_TOUR_FAQ_PARENT : 0));
  };
  const handleChange = (isEnabled) => {
    setSwitcherVal(isEnabled);
    setCorrectionStatus(isEnabled);
    publish(way.CHANGE_CORRECTION_WRONG_ROUTE_STATUS, { isEnabled });
  };
  const optimizeMenuHandler = (isHidden) => {
    if (hiddenMenuDelay) {
      clearTimeout(hiddenMenuDelay);
    }
    if (isHidden) {
      hiddenMenuDelay = setTimeout(() => setMenuHidden(true), 200);
    } else {
      setMenuHidden(isHidden);
    }

    const action = {
      type: types.TOUR_FULL_DATA_SWITCH_TTO_VISIBLE,
      payload: isHidden,
    };
    dispatch(action);
  };

  const isAllSettingsEnabled = () =>
    isAutocorrectionEnabled && isCorrectViaAvailable && isCorrectDragAvailable;

  const getCheckedChildren = () =>
    isAllSettingsEnabled() ? (
      <CheckOutlined />
    ) : (
      <div className="check-outlined-icon" />
    );

  const getWrapperClass = () => {
    if (isFullScreenModeEnabled) {
      return 'correct-all-wrapper hide-oprimize-tour-settings';
    }
    if (isEditMode) {
      return 'correct-all-wrapper';
    }
    return 'correct-all-wrapper relative-maps-toobar';
  };

  const getWrapperActiveClass = () => (!isMenuHidden ? '' : 'active');

  const getFill = () => (!isWrongRoutesExists() ? '#bdbdbc' : '#fff');
  // const getFill = () => (!isWrongRoutesExists() ? '#942820' : '#bdbdbc');
  const handleCorrectAll = () =>
    publish(way.CORRECT_ALL_WRONG_ROUTES_POSITION, {});

  const getCorrectClass = () =>
    !isWrongRoutesExists() ? 'corect-all-wrapper' : 'corect-all-wrapper active';

  const getButtonClass = () =>
    !isWrongRoutesExists()
      ? 'optimize-all-button'
      : 'optimize-all-button active';

  const faqComponent = () => {
    console.log('Here');
    return (
      <FaqComponent
        customeCloseFunc={() => goToFAQ(false)}
        layoutStyle={{
          zIndex: 1101,
          position: 'fixed',
          top: '10vh',
          left: 0,
          right: 0,
        }}
        curtainStyle={{ position: 'fixed', zIndex: 1100 }}
      />
    );
  };

  const getRTComponent = () => {
    if (document.fullscreenElement && isEditMode) {
      return ReactDOM.createPortal(
        <RideTwister fullScreenMode={document.fullscreenElement} />,
        document.querySelector('.TourFullmap')
      );
    }
    if (!document.fullscreenElement && isEditMode) {
      return <RideTwister />;
    }
    return null;
  };

  if (isIE || isMobile) {
    return null;
  }

  return (
    <div
      className={`${getWrapperClass()} ${getWrapperActiveClass()}`}
      style={style}
    >
      <ErrorBoundary>
        {document.fullscreenElement ? (
          ReactDOM.createPortal(
            <div className="map-tools-wrapper map-tools-wrapper-fullscreen">
              <ToolbarLayout
                hasUserPermition={hasUserPermition}
                currentTourId={currentTourId}
                closePreview={closePreview}
                fullScreenMode={fullScreenMode}
              />
            </div>,
            document.querySelector('.TourFullmap')
          )
        ) : (
          <div className="map-tools-wrapper">
            <ToolbarLayout
              hasUserPermition={hasUserPermition}
              currentTourId={currentTourId}
              closePreview={closePreview}
              fullScreenMode={fullScreenMode}
            />
          </div>
        )}
      </ErrorBoundary>

      <div className="optimaze_layout">
        <TTOTitle />
        <div className="autocorrect-wrapper">
          <Suspense fallback={<div />}>
            {isModalOpenFAQ && isOpenFaq
              ? ReactDOM.createPortal(
                  faqComponent(),
                  document.getElementById('root')
                )
              : null}
          </Suspense>
          <Button
            size="large"
            className={getButtonClass()}
            disabled={!isCorrectSwitcherEnabled || !isEditMode}
          >
            <div
              className={getCorrectClass()}
              onClick={handleCorrectAll}
              aria-hidden
            >
              <div className="correct-all-icon">
                <TourCorrectIcon fill={getFill()} />
              </div>
              {tr['Optimize all']}
            </div>
          </Button>
          <div className="correct-all-switcher-wrapper">
            <Switch
              checkedChildren={getCheckedChildren()}
              unCheckedChildren={<CloseOutlined />}
              checked={isCorrectSwitcherEnabled}
              className="correct-all-switcher"
              onChange={handleChange}
              disabled={!isEditMode}
            />
          </div>
          <Button
            size="large"
            className="oprimize-menu-main-button"
            onClick={() => optimizeMenuHandler(!isMenuHidden)}
          >
            <DownOutlined className="drop-down-icon" />
          </Button>
        </div>
        <OptimizeMenu
          isAutocorrectionEnabled={isAutocorrectionEnabled}
          isCorrectViaAvailable={isCorrectViaAvailable}
          isCorrectDragAvailable={isCorrectDragAvailable}
          setAutoCorrectStatus={setAutoCorrectStatus}
          setCorrectViaStatus={setCorrectViaStatus}
          setCorrectDragStatus={setCorrectDragStatus}
          unpaved={unpaved}
          ferry={ferry}
          highway={highway}
          tr={tr}
          goToFAQ={goToFAQ}
          isEditMode={isEditMode}
          isMenuHidden={isMenuHidden}
          optimizeMenuHandler={optimizeMenuHandler}
          isCorrectSwitcherEnabled={isCorrectSwitcherEnabled}
          isShapingVisible={isShapingVisible}
          isRidePlan={isRidePlan}
        />
        {isEditMode ? <ShowPlaces /> : null}
        <ErrorBoundary>{getRTComponent()}</ErrorBoundary>
      </div>
    </div>
  );
};

export default withTranslations(GetSwitcher);
